import { GetBookingStatusRequest } from '@/api/generated/fetch-client';
import { WithRepository } from '@/types/typings';
import { queryOptions, useSuspenseQuery } from '@tanstack/react-query';

import { BookingRepository } from '../repository/booking-repository';
import { useBookingRepository } from '../repository/use-booking-repository';

type Params = GetBookingStatusRequest & {
  refetchInterval?: number;
};

export const useGetBookingStatus = (params: Params) => {
  const repository = useBookingRepository();

  const data = useSuspenseQuery(useGetBookingStatus.options({ repository, ...params }));

  return data;
};

useGetBookingStatus.baseKey = 'bookingStatus';

useGetBookingStatus.keys = (params: GetBookingStatusRequest) => [
  useGetBookingStatus.baseKey,
  params.number,
  'ignoreLoading',
];

useGetBookingStatus.options = ({
  repository,
  refetchInterval,
  ...params
}: WithRepository<Params, BookingRepository>) =>
  queryOptions({
    queryKey: useGetBookingStatus.keys(params),
    queryFn: ({ signal }) => repository.getBookingStatus({ ...params, signal }),
    refetchInterval: refetchInterval,
  });
